import Vue from 'vue'
import App from './App.vue'
import { createRouter } from './router'
import store from './store'
import i18n from './i18n'
import './logger'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import config from '../../common/config.json'
import { ClientTable, ServerTable } from 'vue-tables-2-premium'
import VueAnalytics from 'vue-analytics'
import VueKuzzle from './vueKuzzle'
import keycloakPlugin from '../../common/plugins/keycloakPlugin'
import featureFlagsPlugin from '../../common/plugins/featureFlagsPlugin'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'
import BootstrapVue from 'bootstrap-vue'
// this file contains global imports for common components such as OMButton, OMInput, OMSelect etc...
import 'common-components/ui'
import { offices } from '../../common/constants'

dayjs.extend(customParseFormat)

Vue.prototype.$appName = offices.FRONT_OFFICE
Vue.config.productionTip = false
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(VueKuzzle, config)
Vue.use(BootstrapVue)
Vue.use(ClientTable)
Vue.use(ServerTable)
Vue.use(keycloakPlugin)
Vue.use(featureFlagsPlugin)

const router = createRouter(Vue.prototype.$kuzzle, store)

// GOOGLE ANALYTICS
if (process.env.VUE_APP_BACKEND) {
  const GA_APP_ID =
    process.env.VUE_APP_BACKEND === 'production'
      ? 'UA-163671567-1'
      : 'UA-163608321-1'

  Vue.use(VueAnalytics, {
    id: GA_APP_ID,
  })
}

// SENTRY :
// We want initilize it only for production and staging, not UAT
if (
  process.env.VUE_APP_BACKEND === 'production' ||
  process.env.VUE_APP_BACKEND === 'staging'
) {
  Sentry.init({
    Vue,
    dsn: 'https://d63b294f52ff419089b5fddcbf17f81d@o517154.ingest.sentry.io/6037585',
    environment: process.env.VUE_APP_BACKEND || 'local',
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: [
          'localhost',
          'app.v2.myomniscient.com',
          'app.staging.v2.myomniscient.com',
          'app.uat.v2.myomniscient.com',
        ],
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    //
    // @TODO: set "tracesSampleRate" to 1.0 cause CORS browser errors on local env...
    // This seems to not be related to CORS policies applied on AWS
    // but maybe with the Kuzzle cookie auth login" and URLs set in "accessControlAllowOrigin" on kuzzlerc.
    // We will probably need to change/optimize this ratio,
    // or at least find why there is these errors.
    //
    // Also a high sampling ratio can impact performances, see:
    // https://docs.sentry.io/platforms/javascript/configuration/sampling/#sampling-transaction-events
    tracesSampleRate: 0.1,
  })

  Sentry.setTag('origin', 'app-omniscient')
}

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app')
